import { useEffect } from "react";

import { getInput } from "../../../../../components/ui";
import exhibitionTypeOptions from "../../../../Exhibition/exhibitionTypeOptions";
import { EXHIBITED_OPTIONS } from "../../../../../constants/exhibitedOptions";

const Artfairs = props => {
  const { formik } = props || {};

  useEffect(() => {
    if (formik?.values?.artfairSelectedData?.id) {
      formik.setFieldValue(
        "_exhibitionWork._exhibition.id",
        formik?.values?.artfairSelectedData?.id,
      );
    }
  }, [formik?.values?.artfairSelectedData?.id]);

  const inputs = [
    {
      label: "Art Fair",
      name: "_exhibitionWork._exhibition.id",
      type: "artFairSearch",
      excludeRemoved: true,
    },
    {
      label: "Exhibition Type",
      name: "_exhibitionWork._exhibition.type",
      type: "multi-select",
      options: exhibitionTypeOptions,
    },
    {
      label: "Exhibited",
      name: "_exhibitionWork.exhibited",
      type: "multi-select",
      options: EXHIBITED_OPTIONS,
    },
  ];

  return (
    <div className="mb-5 mt-5 grid grid-cols-4 gap-16">
      {inputs?.map((item, index) => {
        const inputProps = {
          formik,
          ...item,
        };

        return (
          <div key={index} className="grid-cols-1">
            {getInput(inputProps)}
          </div>
        );
      })}
    </div>
  );
};

export default Artfairs;
